<template>
    <div class="sa-list-component">
        <div class="sa-list-component-body">
            <div class="b-table-sticky-header">
                <span class="sa-flexbox-body-title">Progetto: P.R.I</span>
                <!--secondary btn-toolbar sa-margin-right float-sm-right-->
                <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" :hidden="btnAggiungi" @click="onClickAggiungi" class="mb-2">
                    <i class="fas fa-plus"></i>
                    Aggiungi
                </b-button>
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template v-slot:cell(operatore)="{ item }">
                        <span>{{ item.operatore }}</span>
                    </template>
                    <template v-slot:cell(dataIngresso)="{ item }">
                        <span>{{ formatDate(item.createDate) }}</span>
                    </template>
                    <template #cell(action)="{ item }">
                        <b-container class="bv-example-row">
                            <print-component v-if="false" :documentRepository="true" :idRisorsa="item.id" :typeButton="'small'"> </print-component>
                            <b-button v-b-tooltip.hover title="Stampa" size="sm" variant="btn btn-purple waves-effect  waves-light width-sm no-text" style="margin-right: 3px" @click="onClickStampa(item)">
                                <b-icon icon="printer"></b-icon>
                            </b-button>
                            <b-button size="sm" variant="outline-secondary" @click="onClickVisualizzaScheda(item)" title="Visualizza">
                                <font-awesome-icon icon="eye" />
                            </b-button>
                            <!-- :disabled="!item.tipoScheda || item.tipoScheda.trim() !== 'SCHEDA RELAZIONE SANITARIA'"  -->
                            <b-button size="sm" variant="outline-success" @click="onClickModificaScheda(item)" title="Modifica">
                                <font-awesome-icon icon="edit" />
                            </b-button>
                            <b-button size="sm" variant="outline-danger" @click="onClickDeleteScheda(item)" title="Elimina">
                                <font-awesome-icon icon="trash" />
                            </b-button>
                        </b-container>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
        <rsa-paziente-pri-modal-edit ref="cmpRsaPazientePriModal" @afterSave="onAfterSave"></rsa-paziente-pri-modal-edit>
        <pdf-print-view-embedded ref="pdfPrintViewEmbedded" :pdf="signedPdfViewer"></pdf-print-view-embedded>
        <modal-error ref="cmpModalError"></modal-error>
    </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import RsaPazientePriModalEdit from "./RsaPazientePriModalEdit.vue";
import PdfPrintViewEmbedded from "../../../utility/components/PdfPrintViewEmbedded.vue";
export default {
    mixins: [UtilityMixin],
    components: { RsaPazientePriModalEdit, PrintComponent, ModalError, PdfPrintViewEmbedded },
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsapazientepritestata",
            btnAggiungi: false,
            filtroProgettoPri: { idAccettazione: null },
            idAccettazione: "",
            items: [],
            signedPdfViewer: null,
            fields: [
                {
                    label: "Nome Progetto",
                    key: "nomeProgetto",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "Operatore",
                    key: "operatore",
                    sortable: true,
                    thStyle: "width: 18rem",
                },

                {
                    label: "Data",
                    key: "dataIngresso",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "",
                    key: "action",
                    class: "sa-table-column-action-double",
                },
            ],
        };
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(idAccettazione) {
            let me = this;
            me.idAccettazione = idAccettazione;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroProgettoPri"]) {
                me.filtroProgettoPri = JSON.parse(sessionStorage["filtroProgettoPri"]);
            }
            me.filtroProgettoPri.idAccettazione = me.idAccettazione;
            me.filtroProgettoPri.page = me.currentPage;
            me.filtroProgettoPri.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroProgettoPri, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.log(error);
            me.$emit("afterLoadData");
        },
        onClickAggiungi() {
            let me = this;
            //console.log("Aggiungi PRI");
            me.$refs.cmpRsaPazientePriModal.show(me.idAccettazione);
        },

        onClickModificaScheda(item) {
            let me = this;
            me.$refs.cmpRsaPazientePriModal.modificaScheda(item);
        },
        onClickVisualizzaScheda(item) {
            let me = this;
            //console.log("Visualizza PRI", item);
            me.$refs.cmpRsaPazientePriModal.visualizzaScheda(item);
        },
        onAfterSave() {
            let me = this;

            me.loadData();
        },
        onClickDeleteScheda(item) {
            let me = this;
            this.$bvModal
                .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                    title: "Eliminazione Scheda",
                    buttonSize: "sm",
                    okVariant: "secondary",
                    cancelVariant: "danger",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    footerClass: "p-2",
                    hideHeaderClose: false,
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteScheda(item.id);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        deleteScheda(id) {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/" + id;
            axios
                .delete(link)
                .then((response) => {
                    me.loadData();
                    me.showModalLoading = false;
                    me.$emit("onDelete", response);
                    me.$bvToast.toast("Eliminazione avvenuta con successo", {
                        title: "Successo",
                        variant: "success",
                        solid: true,
                    });
                })
                .catch((e) => {
                    console.log(e);
                    me.showModalLoading = false;
                    me.$bvToast.toast("Errore durante l'eliminazione", {
                        title: "Errore",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
        // linkPrintData(item) {
        //     return "/rsaprintdata?idRisorsa=" + item.id + "&idAccettazione=" + item.idAccettazione + "&printDataObjectName=" + item.tipoScheda;
        // },
        onClickStampa(item) {
            let me = this;
            let pathResource = "";
            switch (item.nomeProgetto) {
                case "SCHEMA PROGRAMMA QUADRO":
                    pathResource = "/rsapazienteprischemaprogrammaquadro/printdata/" + item.id;
                    break;
                case "PROGETTO RIABILITATIVO INDIVIDUALE":
                    pathResource = "/rsapazientepriprogettoriabilitativoindividuale/printdata/" + item.id;
                    break;
                default:
                    break;
            }
            me.$emit("beforeLoadData");
            this.loadDataResources(pathResource, null, me.resulResponseStampa, me.resulErrorStampa);
        },
        resulResponseStampa(response) {
            console.log(response);
            let bodyStampa = response.data.data;
            console.log(bodyStampa);
            this.onPrintPreview(bodyStampa);
        },
        resulErrorStampa(error) {
            console.log(error);
            this.$emit("afterLoadData");
        },

        onPrintPreview(item) {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/print/createreport";
            me.showModalLoading = true;
            axios
                .post(link, item)
                .then((response) => {
                    console.log(response);
                    me.signedPdfViewer = "data:application/pdf;base64," + response.data.base64;

                    me.$refs.pdfPrintViewEmbedded.show();
                    me.$emit("afterLoadData");
                })
                .catch((error) => {
                    console.log(error);
                    // me.$refs.mdlGenerazioneReportInCorso.hide();
                    me.showModalLoading = false;
                    let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore non gestito, Codice: " + error.response.status;
                    this.$bvModal
                        .msgBoxOk(messaggio, {
                            title: this.$i18n.t("ERROR!"),
                            size: "sm",
                            okVariant: "outline-danger",
                            headerClass: "sa-msg-header-danger",
                            footerClass: "p-2 border-top-0",
                            centered: true,
                        })
                        .then((value) => {
                            this.boxTwo = value;
                        })
                        .catch((err) => {
                            err;
                        });
                });
        },
    },
};
</script>

<style></style>
